import { IgrColumnSortDescriptionCollection } from "./igr-column-sort-description-collection";
import { GridSortDescriptionsChangedEventArgs as GridSortDescriptionsChangedEventArgs_internal } from "./GridSortDescriptionsChangedEventArgs";
/**
 * Information about the current sorting applied to the grid.
*/
var IgrGridSortDescriptionsChangedEventArgs = /** @class */ /*@__PURE__*/ (function () {
    function IgrGridSortDescriptionsChangedEventArgs() {
        this._implementation = this.createImplementation();
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    }
    IgrGridSortDescriptionsChangedEventArgs.prototype.createImplementation = function () {
        return new GridSortDescriptionsChangedEventArgs_internal();
    };
    Object.defineProperty(IgrGridSortDescriptionsChangedEventArgs.prototype, "i", {
        /**
         * @hidden
         */
        get: function () {
            return this._implementation;
        },
        enumerable: true,
        configurable: true
    });
    IgrGridSortDescriptionsChangedEventArgs.prototype.onImplementationCreated = function () {
    };
    IgrGridSortDescriptionsChangedEventArgs.prototype._provideImplementation = function (i) {
        this._implementation = i;
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    };
    Object.defineProperty(IgrGridSortDescriptionsChangedEventArgs.prototype, "sortDescriptions", {
        get: function () {
            if (this.i.sortDescriptions == null) {
                return null;
            }
            if (!this.i.sortDescriptions.externalObject) {
                var e = new IgrColumnSortDescriptionCollection();
                e._implementation = this.i.sortDescriptions;
                this.i.sortDescriptions.externalObject = e;
            }
            return this.i.sortDescriptions.externalObject;
        },
        set: function (v) {
            v == null ? this.i.sortDescriptions = null : this.i.sortDescriptions = v.i;
        },
        enumerable: true,
        configurable: true
    });
    return IgrGridSortDescriptionsChangedEventArgs;
}());
export { IgrGridSortDescriptionsChangedEventArgs };
//# sourceMappingURL=igr-grid-sort-descriptions-changed-event-args.js.map
